// Tagi artykułów Bazy wiedzy. Zamknięta lista: nowy tag dopisz tutaj, a test (tagi.test.js)
// pilnuje, żeby artykuł miał 3 do 15 tagów z tej listy i żeby każdy tag miał co najmniej 2 artykuły.
// Tag dostaje artykuł, który jest o tej sprawie, a nie taki, który tylko o niej wspomina.
export const GRUPY_TAGOW = [
  {
    nazwa: 'Marki',
    tagi: {
      deye: 'Deye',
      hoymiles: 'Hoymiles',
      sigenergy: 'Sigenergy',
      huawei: 'Huawei',
      foxess: 'FoxESS',
      dyness: 'Dyness',
      byd: 'BYD',
      pylontech: 'Pylontech',
      sofar: 'Sofar',
      sma: 'SMA',
      fronius: 'Fronius',
      solaredge: 'SolarEdge',
    },
  },
  {
    nazwa: 'Technologia',
    tagi: {
      'magazyn-lv': 'Magazyn LV',
      'magazyn-hv': 'Magazyn HV',
      'falownik-hybrydowy': 'Falownik hybrydowy',
      fazy: '1 czy 3 fazy',
      mppt: 'MPPT i stringi',
      'moduly-pv': 'Moduły PV',
      backup: 'Zasilanie awaryjne',
      ems: 'EMS',
      'pobor-wlasny': 'Pobór własny',
      zgodnosc: 'Zgodność urządzeń',
      wallbox: 'Wallbox',
      'wallbox-do-auta': 'Wallbox do auta',
      rozbudowa: 'Rozbudowa',
      diagnostyka: 'Diagnostyka',
    },
  },
  {
    nazwa: 'Sprawy',
    tagi: {
      pme2: 'Dotacje PME2',
      formalnosci: 'Formalności',
      osd: 'Zgłoszenie do OSD',
      'moc-przylaczeniowa': 'Moc przyłączeniowa',
      certyfikat: 'Certyfikat NC RfG',
      ppoz: 'Ochrona ppoż.',
      ceny: 'Ceny',
      oplacalnosc: 'Opłacalność',
      'net-billing': 'Net-billing',
      dynamiczna: 'Taryfa dynamiczna',
      autokonsumpcja: 'Autokonsumpcja',
      gwarancja: 'Gwarancja',
      oferty: 'Porównanie ofert',
      firmy: 'Dla firm PV',
      'fakty-i-mity': 'Fakty i mity',
    },
  },
]

export const ETYKIETY_TAGOW = Object.assign({}, ...GRUPY_TAGOW.map((g) => g.tagi))

const WALLBOX_DO_AUTA = ['wallbox', 'wallbox-do-auta', 'ceny']
const WNIOSEK_PME2 = ['pme2', 'formalnosci', 'osd']

export const TAGI_ARTYKULOW = {
  // Falowniki
  'falownik-1-fazowy-czy-3-fazowy': ['fazy', 'osd', 'mppt'],
  'falownik-1-fazowy-przy-przylaczu-3-fazowym': ['fazy', 'osd', 'rozbudowa'],
  'ile-paneli-w-stringu': ['mppt', 'moduly-pv', 'huawei', 'sma'],
  'ile-paneli-na-falownik-przewymiarowanie': ['mppt', 'moduly-pv', 'falownik-hybrydowy', 'deye', 'huawei', 'sofar', 'fronius'],
  'dwa-stringi-na-jednym-mppt': ['mppt', 'moduly-pv', 'sofar', 'fronius'],
  'zasilanie-awaryjne-fotowoltaika-caly-dom-czy-wybrane-obwody': ['backup', 'falownik-hybrydowy', 'ceny', 'oplacalnosc', 'pobor-wlasny', 'pme2', 'fakty-i-mity', 'deye', 'hoymiles', 'sigenergy', 'huawei', 'foxess', 'solaredge'],
  'pobor-wlasny-falownika-hybrydowego': ['pobor-wlasny', 'falownik-hybrydowy', 'oplacalnosc', 'fakty-i-mity', 'deye', 'hoymiles', 'sigenergy'],
  'falownik-wylacza-sie-253-v': ['diagnostyka', 'osd', 'fakty-i-mity', 'deye', 'foxess'],
  'hoymiles-hit-czy-deye-sg05lp3': ['hoymiles', 'deye', 'falownik-hybrydowy', 'mppt', 'certyfikat', 'gwarancja', 'ceny', 'pobor-wlasny', 'fakty-i-mity'],
  // Magazyny
  'ems-dotacja-pme2-wymagania': ['ems', 'pme2', 'fakty-i-mity', 'deye', 'hoymiles', 'sigenergy'],
  'dotacja-na-magazyn-energii-pme2': ['pme2', 'ceny', 'ems'],
  'wniosek-pme2-krok-po-kroku': WNIOSEK_PME2,
  'formularz-wniosku-pme2-gwd-pole-po-polu': WNIOSEK_PME2,
  'pme2-zmiany-po-starcie-naboru': WNIOSEK_PME2,
  'czy-magazyn-energii-sie-oplaca': ['oplacalnosc', 'net-billing', 'pme2', 'ceny', 'dynamiczna'],
  'ile-kosztuje-magazyn-energii': ['ceny', 'magazyn-lv', 'magazyn-hv', 'pme2'],
  'jaki-magazyn-energii-do-falownika': ['zgodnosc', 'magazyn-lv', 'magazyn-hv', 'deye', 'hoymiles', 'sigenergy', 'huawei', 'foxess', 'dyness', 'byd', 'pylontech', 'sofar', 'sma', 'fronius', 'solaredge'],
  'magazyn-energii-do-istniejacej-instalacji-fotowoltaicznej': ['rozbudowa', 'zgodnosc', 'falownik-hybrydowy', 'backup', 'ceny', 'huawei', 'foxess', 'sofar', 'hoymiles', 'sma', 'deye'],
  'falownik-nie-laduje-magazynu-energii-diagnostyka': ['diagnostyka', 'zgodnosc', 'deye'],
  'rozbudowa-magazynu-energii': ['rozbudowa', 'gwarancja', 'magazyn-lv', 'magazyn-hv', 'pme2', 'osd', 'ppoz', 'fakty-i-mity', 'deye', 'huawei', 'foxess', 'dyness', 'byd', 'pylontech'],
  'magazyn-energii-lv-czy-hv': ['magazyn-lv', 'magazyn-hv', 'ceny', 'rozbudowa', 'fakty-i-mity', 'deye', 'hoymiles', 'dyness', 'pylontech'],
  'jak-dobrac-magazyn-energii-do-fotowoltaiki': ['magazyn-lv', 'magazyn-hv', 'zgodnosc', 'autokonsumpcja', 'oplacalnosc', 'net-billing', 'backup', 'gwarancja'],
  'sigenergy-pstryk-magazyn-taryfa-dynamiczna': ['sigenergy', 'dynamiczna', 'ceny', 'backup', 'pobor-wlasny'],
  // Instalacje PV
  'gwarancja-rekojmia-fotowoltaika-magazyn': ['gwarancja', 'oferty', 'formalnosci', 'fakty-i-mity', 'deye', 'hoymiles', 'dyness', 'sigenergy'],
  'jak-porownac-oferty-na-instalacje-pv': ['oferty', 'ceny', 'gwarancja', 'ppoz'],
  'oferta-fotowoltaika-z-magazynem-co-sprawdzic': ['oferty', 'ceny', 'gwarancja', 'zgodnosc', 'falownik-hybrydowy', 'backup', 'pme2'],
  'fotowoltaika-powyzej-6-5-kw-ppoz-zawiadomienie-psp': ['ppoz', 'formalnosci', 'ceny'],
  'magazyn-energii-2-2-mocy-instalacji-nowelizacja-oze': ['moc-przylaczeniowa', 'osd', 'formalnosci', 'pme2'],
  'zgloszenie-mikroinstalacji-do-osd': ['osd', 'formalnosci', 'moc-przylaczeniowa', 'certyfikat'],
  'zgloszenie-magazynu-energii-do-osd': ['osd', 'formalnosci', 'moc-przylaczeniowa', 'pme2'],
  'certyfikat-nc-rfg-falownik-wykaz-ptpiree': ['certyfikat', 'osd', 'formalnosci'],
  'czy-fotowoltaika-sie-oplaca': ['oplacalnosc', 'ceny', 'net-billing', 'autokonsumpcja'],
  'cena-fotowoltaiki-za-kwp': ['ceny', 'oferty', 'moduly-pv'],
  'ile-kosztuje-fotowoltaika-z-magazynem-energii': ['ceny', 'oferty', 'pme2', 'falownik-hybrydowy'],
  'fotowoltaika-2027-ile-zaplacisz-ceny-z-ofert': ['ceny', 'oferty', 'pme2'],
  'program-do-wyceny-fotowoltaiki': ['firmy', 'oferty', 'ceny'],
  'jak-przygotowac-oferte-na-fotowoltaike': ['firmy', 'oferty', 'pme2', 'net-billing', 'gwarancja'],
  'pstryk-opinie-czy-cena-dynamiczna-sie-oplaca': ['dynamiczna', 'oplacalnosc', 'ceny'],
  'taryfa-dynamiczna-czy-sie-oplaca': ['dynamiczna', 'oplacalnosc', 'ceny', 'net-billing'],
  // Ładowarki EV
  'wallbox-11-czy-22-kw': ['wallbox', 'wallbox-do-auta', 'moc-przylaczeniowa'],
  'ladowanie-auta-z-fotowoltaiki': ['wallbox', 'autokonsumpcja', 'net-billing', 'huawei', 'fronius', 'solaredge'],
  'jaki-wallbox-do-tesla-model-3': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-tesla-model-y': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-skoda-enyaq': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-volkswagen-id4': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-kia-ev6': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-hyundai-ioniq-5': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-toyota-bz4x': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-bmw-ix1': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-volvo-ex30': WALLBOX_DO_AUTA,
  'jaki-wallbox-do-dacia-spring': WALLBOX_DO_AUTA,
  // Moduły PV
  'jak-dobrac-panel-fotowoltaiczny-do-rozbudowy-instalacji': ['moduly-pv', 'rozbudowa', 'mppt'],
  'czy-mozna-mieszac-rozne-modele-paneli-fotowoltaicznych': ['moduly-pv', 'rozbudowa', 'mppt'],
}

export const tagiArtykulu = (slug) => TAGI_ARTYKULOW[slug] || []
export const etykietyArtykulu = (slug) => tagiArtykulu(slug).map((t) => ETYKIETY_TAGOW[t])
